import React from 'react'
import Form from './form'

export default () => (
  <div className="card login-card">
    <div className="card-content text-left">
      <Form />
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/containers/pages/users/sign_up/index.js